import Handler, { ResultHandler } from "./Handler";

export default class JoinMessagesHandler extends Handler {
  private token: string;
  private messagesIds: string[];

  constructor(token: string) {
    super();
    this.token = token;
    this.messagesIds = [];
  }

  setMessagesIds(ids: string[]) {
    this.messagesIds = ids;
  }

  public async handle(): Promise<ResultHandler> {
    try {
      await this.request.post(
        `${this.baseURL}/messages/join/${this.token}`,
        { idMensagens: this.messagesIds }
      );
      return { result: true };
    } catch (error) {
      console.error(error);
      return { result: false, error: String(error) };
    }
  }
}
